<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { onMounted, ref } from 'vue'
import FileUpload from '../../../../components/ui/form/FileUpload.vue'
import NumberInput from '../../../../components/ui/form/NumberInput.vue'
import GroupedSelect from '../../../../components/ui/form/GroupedSelect.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  image: props.data?.image || "",
    citys_id: props.data?.citys_id || "",
    roads_id: props.data?.roads_id || "",
    no_of_floors: props.data?.no_of_floors || 1,
    has_lift: props.data?.citys_id || false,
    lat: props.data?.lat || "",
    lng: props.data?.lng || "",
    name: props.data?.name || props.listCreateName || "",
    active: props.data?.active || true,
    uid: props.data?.uid || "",
  });

setFieldRules("citys_id", [required("City is required")]);
setFieldRules("name", [required("Name is required")]);


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          label="Image"
          :max-size="5"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="brands"
          v-model="fields.image.value"
        />
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.name.value"
          label="Name"
          placeholder="Enter Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />

        <div class="grid md:grid-cols-2 gap-4">
          <NumberInput
          v-model="fields.no_of_floors.value"
          label="No. of Floors"
          :readonly="isReadOnly"
          :min="0"
          :error="
            fields.no_of_floors.touched ? fields.no_of_floors.error : null
          "
          @blur="fields.no_of_floors.touched = true"
        />

        <CheckInput
          v-model="fields.has_lift.value"
          :readonly="isReadOnly"
          label="Have Lift"
          :error="fields.has_lift.touched ? fields.has_lift.error : null"
          @blur="fields.has_lift.touched = true"
        />
        </div>


        <GroupedSelect
          v-model="fields.citys_id.value"
          label="City"
          end-point="system/master-data/citys"          
          :allowNewRecord="true"
          optionLabel="citys"
          :readonly="isReadOnly"
          :error="fields.citys_id.touched ? fields.citys_id.error : null"
          @blur="fields.citys_id.touched = true"
        />

        <SearchSelect
          v-model="fields.roads_id.value"
          label="Road"
          end-point="system/master-data/roads"
          :extra="fields.citys_id.value"
          :allowNewRecord="true"
          :hasExtra="true"
          :readonly="isReadOnly"
          :error="fields.roads_id.touched ? fields.roads_id.error : null"
          @blur="fields.roads_id.touched = true"
        />

        <NumberInput
          v-model="fields.lat.value"
          label="Latitude"
          :readonly="isReadOnly"
          :min="0"
          :error="fields.lat.touched ? fields.lat.error : null"
          @blur="fields.lat.touched = true"
        />

        <NumberInput
          v-model="fields.lng.value"
          label="Longitude"
          :readonly="isReadOnly"
          :min="0"
          :error="fields.lng.touched ? fields.lng.error : null"
          @blur="fields.lng.touched = true"
        />

        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>